import {
    setProfile,
    setVoiceName,
    setSelectedLang,
    setAudioUrl,
    setAudioBlob,
    setCreateCloneStatus,
    setAudioName,
    setIsShowVoiceEditModal,
    setVoiceCloneEditProfileId,
    setVoiceCloneEditName,
    setPreviewAudioUrl,
    setIsUploading,
} from '../slices/FJSliceVoiceCloning.js';
import FJMessageStore from '../../store/FJMessageStore.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJUtil from '../../util/FJUtil.js';
import FJConstant from '../../constants/FJConstant.js';
import { setSliceTaskStatusAction } from '../slices/FJSliceCommon.js';
import FJActionCommon from './FJActionCommon.js';
import { AI_VOICE_CLONE_USE_CREDIT } from '../slices/FJSliceVoiceCloning.js';
import FJActionModal from './FJActionModal.js';
import FJConfig from '../../config/FJConfig.js';
import FJImageStore from '../../store/FJImageStore.js';
import FJS3Config from '../../config/FJS3Config.js';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import FJVideoUtil from '../../util/FJVideoUtil.js';
import FJActionRecord from './FJActionRecord.js';
import FJCloudTranscodingUtil from '../../util/FJCloudTranscodingUtil.js';
import { CLOUD_TRANSCODE_SUPPORTED_FORMATS } from '../../config/dataConfig/FJCloudTranscodingData.js';

let f_eventId = null;

const SUPPORTED_VIDEO_FORMATS = ['mp4'];
const SUPPORTED_AUDIO_FORMATS = ['mp3', 'wav'];

const _getTranscodeConfig = file => {
    const fileExtension = FJCloudTranscodingUtil.getFileExtensionFromFile(file);
    const isVideo = CLOUD_TRANSCODE_SUPPORTED_FORMATS.video.input.includes(fileExtension);
    const isAudio = CLOUD_TRANSCODE_SUPPORTED_FORMATS.audio.input.includes(fileExtension);
    if (isVideo) {
        return {
            needTranscode: !SUPPORTED_VIDEO_FORMATS.includes(fileExtension),
            mediaType: 'video',
            outputFormat: 'mp4',
            isVideo,
            isAudio,
        };
    } else if (isAudio) {
        return {
            needTranscode: !SUPPORTED_AUDIO_FORMATS.includes(fileExtension),
            mediaType: 'audio',
            outputFormat: 'wav',
            isVideo,
            isAudio,
        };
    } else {
        throw new Error('unsupported-file-format-please-upload-again');
    }
};

const FJActionVoiceCloning = {
    setIsUploadingAction: function (isUploading) {
        return dispatch => {
            dispatch(setIsUploading(isUploading));
        };
    },
    setProfileAction: function (profile) {
        return dispatch => {
            dispatch(setProfile(profile));
        };
    },
    setVoiceNameAction: function (voiceName) {
        return dispatch => {
            dispatch(setVoiceName(voiceName));
        };
    },
    setSelectedLangAction: function (lang) {
        return dispatch => {
            dispatch(setSelectedLang(lang));
        };
    },
    setAudioUrlAction: function (audioUrl) {
        return dispatch => {
            dispatch(setAudioUrl(audioUrl));
        };
    },
    setAudioBlobAction: function (audioBlob) {
        return dispatch => {
            dispatch(setAudioBlob(audioBlob));
        };
    },
    setAudioNameAction: function (audioName) {
        return dispatch => {
            dispatch(setAudioName(audioName));
        };
    },
    setCreateCloneStatusAction: function (status) {
        return dispatch => {
            dispatch(setCreateCloneStatus(status));
        };
    },

    setPreviewAudioUrlAction: function (url) {
        return dispatch => {
            dispatch(setPreviewAudioUrl(url));
        };
    },
    setIsShowVoiceEditModalAction: function (bool) {
        return dispatch => {
            dispatch(setIsShowVoiceEditModal(bool));
        };
    },
    setVoiceCloneEditProfileIdAction: function (profileId) {
        return dispatch => {
            dispatch(setVoiceCloneEditProfileId(profileId));
        };
    },
    setVoiceCloneEditNameAction: function (name) {
        return dispatch => {
            dispatch(setVoiceCloneEditName(name));
        };
    },

    updateVoiceCloneAction: function (hasLength, options = {}) {
        return dispatch => {
            const { ignoreLength = false, ignoreCloneStatus = false } = options;
            if (hasLength) {
                if (ignoreCloneStatus) {
                    return;
                }
                if (ignoreLength) {
                    dispatch(this.setCreateCloneStatusAction(FJConstant.DEFAULT));
                } else {
                    dispatch(this.setCreateCloneStatusAction(FJConstant.HISTORY_LIST));
                }
            } else {
                dispatch(this.setCreateCloneStatusAction(FJConstant.DEFAULT));
            }
        };
    },

    resetAction: function () {
        return dispatch => {
            dispatch(this.setCreateCloneStatusAction(FJConstant.DEFAULT));
            dispatch(this.setAudioBlobAction(''));
            dispatch(this.setAudioUrlAction(''));
            dispatch(this.setAudioNameAction(''));
            dispatch(this.setVoiceNameAction(''));
            dispatch(this.setSelectedLangAction('en'));
            dispatch(this.setProfileAction('default'));
        };
    },

    applyRecordAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const audioName = state.record.audioName;
            const audioUrl = state.record.audioUrl;
            const mimeType = 'audio/mpeg';
            const audioBlob = await FJUtil.getBlobByUrl(audioUrl);
            const audioFile = new File([audioBlob], audioName, { type: mimeType });
            dispatch(this.uploadAudioInVoiceCloneAction(audioFile, { source: 'record' }));
            dispatch(FJActionModal.hideRecordModalAction());
            dispatch(FJActionRecord.setRecordStatusAction(FJConstant.DEFAULT));
            dispatch(FJActionRecord.setAudioUrlAction(''));
            dispatch(FJActionRecord.setAudioNameAction(''));
        };
    },

    uploadAudioInVoiceCloneAction: function (file, options = {}) {
        return async (dispatch, getState) => {
            const { source, skipTranscode = false } = options;
            dispatch(this.setIsUploadingAction(true));
            let errorDuration = 0;
            try {
                const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB
                const MIN_DURATION = 10; // 30秒
                const MAX_DURATION = 90; // 90秒
                // 检查文件类型
                const { needTranscode, mediaType, outputFormat, isVideo } = _getTranscodeConfig(file);

                // 避免循环转码
                if (needTranscode && !skipTranscode) {
                    // 使用转码功能

                    try {
                        const result = await dispatch(
                            FJActionModal.showCloudTranscodingModalAction({
                                files: [file],
                                mediaType,
                                outputFormat,
                                onReupload: newFiles => {
                                    if (newFiles && newFiles.length > 0) {
                                        // 重新上传文件
                                        dispatch(this.uploadAudioInVoiceCloneAction(newFiles[0], { source }));
                                    }
                                },
                            }),
                        );
                        // 直接使用转码后的文件
                        file = result.files[0];

                        // 兼容Safari浏览器
                        const isSafari = FJUtil.getBrowser().includes('Safari');
                        const isFirefox = FJUtil.getBrowser().includes('FF');
                        if (isSafari || isFirefox) {
                            file = new File([file], file.name.split('.')[0] + '.mp3', {
                                type: 'audio/mpeg',
                            });
                        } else {
                            file = result.files[0];
                        }
                    } catch (e) {
                        dispatch(this.setIsUploadingAction(false));
                        return;
                    }
                }

                // 检查文件大小
                if (file.size > MAX_FILE_SIZE) {
                    throw new Error('please-upload-files-within-30mb');
                }

                let audioFile = file;
                const blobUrl = URL.createObjectURL(audioFile);
                let mediaDuration = null;
                if (isVideo) {
                    // TODO: 音视频分离获取音频
                    mediaDuration = await FJVideoUtil.getVideoDurationWithUrl(blobUrl);
                    errorDuration = mediaDuration;
                    // 检查音频时长
                    if (mediaDuration < MIN_DURATION || mediaDuration > MAX_DURATION) {
                        throw new Error('please-upload-a-file-between-30-90-seconds');
                    }
                    audioFile = await FJVideoUtil.getAudioFromVideo(file);
                } else {
                    try {
                        mediaDuration = await FJUtil.getAudioDurationWithUrl(blobUrl);
                        mediaDuration = Math.floor(mediaDuration);
                        errorDuration = mediaDuration;
                    } catch (e) {
                        throw new Error('unsupported-file-format-please-upload-again');
                    }

                    // 检查音频时长
                    if (mediaDuration < MIN_DURATION || mediaDuration > MAX_DURATION) {
                        throw new Error('please-upload-a-file-between-30-90-seconds');
                    }
                }

                FJUtil.eaLog('clone_file_upload_success', {
                    file_format: file.type,
                    file_size: Math.floor((file.size / 1024 / 1024) * 100) / 100,
                    file_duration: mediaDuration,
                    source: source,
                });
                // 创建音频URL并更新状态
                if (
                    FJConstant.DEFAULT === getState().voiceCloning.createCloneStatus &&
                    getState().voiceCloning.isUploading === true
                ) {
                    dispatch(this.setAudioBlobAction(audioFile));
                    dispatch(this.setAudioUrlAction(blobUrl));
                    dispatch(this.setAudioNameAction(audioFile.name));
                    dispatch(this.setCreateCloneStatusAction(FJConstant.SETTING));
                }
                dispatch(this.setIsUploadingAction(false));
            } catch (error) {
                if (FJConstant.DEFAULT === getState().voiceCloning.createCloneStatus) {
                    FJMessageStore.addMessage(FJLocalStore._(error.message), 'error');
                }
                dispatch(this.setIsUploadingAction(false));
                FJUtil.eaLog('clone_file_upload_failed', {
                    file_format: file.type,
                    file_size: Math.floor((file.size / 1024 / 1024) * 100) / 100,
                    file_duration: errorDuration,
                });
            }
        };
    },

    generateErrorAction: function () {
        return () => {
            FJMessageStore.addMessage(FJLocalStore._('cloning-failed-please-try-again-later'), 'error');
        };
    },

    onGenerateAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const { profileId, voiceName, selectedLang, audioBlob } = state.voiceCloning;
            const creditNumber = state.common.creditNumber;
            const freeNumCreation = state.textToSpeech.freeNumCreationOfVoiceClone;

            FJUtil.eaLog('voice_clone_detail', { voice_clone_language: selectedLang });

            const _voiceName = voiceName.replace(/\s/g, '');
            if (_voiceName.length === 0 || voiceName.length === 0) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-a-name-first'), 'error');
                return;
            }

            dispatch(setSliceTaskStatusAction(FJConstant.START));

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    dispatch(this.generateErrorAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                },
                beforeLoginCallback: () => {
                    dispatch(this.generateErrorAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                },
            });

            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            if (AI_VOICE_CLONE_USE_CREDIT > creditNumber && freeNumCreation === 0) {
                dispatch(FJActionModal.showUpgradeModalAction());
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            const isFree = AI_VOICE_CLONE_USE_CREDIT > creditNumber && freeNumCreation > 0;

            dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));

            const _dealFile = async () => {
                const id = await FJUtil.hashEncode(audioBlob);

                const key = FJConfig.originalAudioKey + id + '.' + FJUtil.getFileSuffix(audioBlob.name);
                const result = await FJImageStore.upLoadFileToS3Async(audioBlob, key);
                if (result) {
                    return FJS3Config.S3_SERVER_HOST + key;
                } else {
                    dispatch(this.generateErrorAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                }
            };

            const useAudioUrl = await _dealFile();

            FJUtil.eaLog(' ai tool start generating', {
                tool: 'voice_cloning',
                'credit&free': isFree ? 'free' : 'credit',
            });

            // AI生成音乐
            const _request = async () => {
                return await FJNetworkStore.voiceClone({
                    audioUrl: useAudioUrl,
                    selectLang: selectedLang,
                    name: voiceName,
                    avatar: profileId,
                });
            };

            try {
                const eventId = await FJActionCommon.createRequestTask(_request, dispatch);
                FJUtil.updateAllCreditInfo(isFree);

                const callback = data => {
                    const { type, finishTaskCreationList } = data;
                    if (type === FJConstant.ERROR) {
                        dispatch(this.generateErrorAction());
                        dispatch(FJActionModal.hideGenerateLoadingModalAction());
                    } else if (type === FJConstant.SUCCESS) {
                        dispatch(this.setCreateCloneStatusAction(FJConstant.SUCCESS));
                        dispatch(this.setPreviewAudioUrlAction(finishTaskCreationList[0].audioUrl));
                        dispatch(FJActionModal.hideGenerateLoadingModalAction());

                        FJUtil.eaLog('ai tool generate success', {
                            tool: 'voice_cloning',
                            'credit&free': isFree ? 'free' : 'credit',
                        });
                    }
                };
                dispatch(
                    FJActionCommon.pollingTaskAction([eventId], {
                        callback,
                        isUseFree: isFree,
                        ignoreCloneStatus: true,
                    }),
                );
            } catch (e) {
                dispatch(this.generateErrorAction());
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
            }
        };
    },

    showVoiceCloneEditAction: function (info) {
        return dispatch => {
            dispatch(this.setVoiceCloneEditProfileIdAction(info.avatar));
            dispatch(this.setVoiceCloneEditNameAction(info.name));
            dispatch(this.setIsShowVoiceEditModalAction(true));
            f_eventId = info.eventId;
        };
    },

    hideVoiceCloneEditAction: function () {
        return dispatch => {
            dispatch(this.setIsShowVoiceEditModalAction(false));
            dispatch(this.setVoiceCloneEditProfileIdAction(''));
            dispatch(this.setVoiceCloneEditNameAction(''));
            f_eventId = null;
        };
    },

    editVoiceCloneInfoAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const { voiceCloneEditProfileId, voiceCloneEditName } = state.voiceCloning;

            const _voiceName = voiceCloneEditName.replace(/\s/g, '');
            if (_voiceName.length === 0 || voiceCloneEditName.length === 0) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-a-name-first'), 'error');
                return;
            }

            try {
                const result = await FJNetworkStore.updateEventInfo({
                    eventId: f_eventId,
                    info: { name: voiceCloneEditName, avatar: voiceCloneEditProfileId },
                });
                if (result.code === 200) {
                    dispatch(FJActionCommon.updateHistoryListAction());
                    dispatch(this.hideVoiceCloneEditAction());
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-save-please-try-again-later'), 'error');
                }
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-save-please-try-again-later'), 'error');
            }
        };
    },
};

export default FJActionVoiceCloning;
